import BASE_URL from "../config";

export const getProducts = async ({
  categoryId = "",
  subcategoryId = "",
  search = "",
  sortBy = "",
  page = 1,
  limit = 12,
  signal,
} = {}) => {
  try {
    const params = new URLSearchParams();

    if (categoryId) {
      params.append(
        "categoryId",
        categoryId
      );
    }

    if (subcategoryId) {
      params.append(
        "subcategoryId",
        subcategoryId
      );
    }

    // Free-text search across name, description, origin and
    // category/subcategory names (server-side, whole catalogue)
    if (search && search.trim()) {
      params.append("search", search.trim());
    }

    // newest (default) | priceAsc | priceDesc | nameAsc
    if (sortBy) {
      params.append("sortBy", sortBy);
    }

    params.append("page", page);
    params.append("limit", limit);

    const response = await fetch(
      `${BASE_URL}/products?${params.toString()}`,
      { signal }
    );

    if (!response.ok) {
      throw new Error(
        `Products API failed: ${response.status}`
      );
    }

    const result =
      await response.json();

    return result;
  } catch (error) {
    // A superseded search request being cancelled isn't a failure
    if (error?.name !== "AbortError") {
      console.error(
        "getProducts Error:",
        error
      );
    }

    throw error;
  }
};

export const getProductById = async (
  id
) => {
  try {
    const response = await fetch(
      `${BASE_URL}/products/${id}`
    );

    if (!response.ok) {
      throw new Error(
        `Product API failed: ${response.status}`
      );
    }

    const result =
      await response.json();

    return result;
  } catch (error) {
    console.error(
      "getProductById Error:",
      error
    );

    throw error;
  }
};